import type { WalletAccount } from '../walletAccount';

type isWalletAccountVerifiedParams = {
  walletAccount: WalletAccount;
};

/**
 * Checks if a wallet account has been verified by a user.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account has been verified, false otherwise.
 */
export const isWalletAccountVerified = ({
  walletAccount,
}: isWalletAccountVerifiedParams) => {
  return walletAccount.verifiedCredentialId !== null;
};
